// composables/usePedidoBadges.js
// Funciones puras de formato visual. Sin estado reactivo.
// Importar en cualquier componente que necesite badges o labels.

export function usePedidoBadges() {

  function formatFecha(f) {
    if (!f) return "—"
    return new Date(f + "T00:00:00").toLocaleDateString("es-MX", {
      day: "2-digit", month: "short", year: "numeric",
    })
  }

  function labelDias(dias) {
    if (dias == null) return "—"
    if (dias < 0)    return `${Math.abs(dias)}d atraso`
    if (dias === 0)  return "Vence hoy"
    return `${dias} días`
  }

  function badgeDias(dias) {
    if (dias == null || dias < 0) return "badge-estatus atrasado"
    if (dias <= 3)                return "badge-estatus entrega_con_atraso"
    return "badge-estatus en_tiempo"
  }

  function badgePrioridad(p) {
    return {
      "badge-prioridad alta":  p === "Alta",
      "badge-prioridad media": p === "Media",
      "badge-prioridad baja":  p === "Baja",
    }
  }

  function badgeEstatusAlmacen(e) {
    return {
      "badge-estatus en_proceso": e === "En proceso",
      "badge-estatus listo":      e === "Listo para entrega",
      "badge-estatus entregado":  e === "Entregado",
      "badge-estatus cancelado":  e === "Cancelado",
    }
  }

  function badgeEstatusCliente(e) {
    return {
      "badge-estatus en_tiempo":          e === "En tiempo",
      "badge-estatus atrasado":           e === "Atrasado",
      "badge-estatus entrega_en_tiempo":  e === "Entrega en tiempo",
      "badge-estatus entrega_con_atraso": e === "Entrega con atraso",
      "badge-estatus cancelado":          e === "Cancelado",
    }
  }

  function labelEstatus(e) {
    return {
      en_proceso: "En proceso", listo: "Listo",
      entregado: "Entregado",   cancelado: "Cancelado",
    }[e] || e
  }

  function labelEstatusCliente(e) {
    return {
      en_tiempo:          "En tiempo",
      atrasado:           "Atrasado",
      entrega_en_tiempo:  "Entregado ✓",
      entrega_con_atraso: "Entregado tarde",
      cancelado:          "Cancelado",
    }[e] || e || "—"
  }

  function rowClaseItem(item) {
    if (!item.articulo_id)                    return "row-sin-match"
    if (item._desdeIa && item.confianza < 80) return "row-match-bajo"
    return ""
  }

  return {
    formatFecha, labelDias, badgeDias,
    badgePrioridad, badgeEstatusAlmacen, badgeEstatusCliente,
    labelEstatus, labelEstatusCliente, rowClaseItem,
  }
}